import React from 'react';

interface AttendeeStatsProps {
  counts: {
    approved: number;
    checkedIn: number;
    notCheckedIn: number;
    availableSpots: number;
    capacityPercentage: number;
    clients: number;
    prospects: number;
    partners: number;
    staff: number;
    unspecified?: number;
  };
  maxAttendees: number;
}

const AttendeeStats: React.FC<AttendeeStatsProps> = ({ counts, maxAttendees }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6 p-4 bg-gray-50 rounded-lg">
      <div>
        <p className="text-xs font-medium text-gray-500 uppercase">Capacity</p>
        <p className="text-lg sm:text-2xl font-bold text-gray-900">
          {counts.approved}/{maxAttendees}
        </p>
        <p className="text-xs text-gray-600">{counts.capacityPercentage}% full</p>
      </div>
      
      <div>
        <p className="text-xs font-medium text-gray-500 uppercase">Checked In</p>
        <p className="text-lg sm:text-2xl font-bold text-green-600">{counts.checkedIn}</p>
        <p className="text-xs text-gray-600">{counts.notCheckedIn} not checked</p>
      </div>
      
      <div>
        <p className="text-xs font-medium text-gray-500 uppercase">Available</p>
        <p className="text-lg sm:text-2xl font-bold text-blue-600">{counts.availableSpots}</p>
        <p className="text-xs text-gray-600">spots remaining</p>
      </div>
      
      <div>
        <p className="text-xs font-medium text-gray-500 uppercase">Attendee Mix</p>
        <p className="text-xs mt-1">
          Clients: {counts.clients}, Prospects: {counts.prospects}
        </p>
        <p className="text-xs text-gray-600">
          Partners: {counts.partners}, Staff: {counts.staff}
        </p>
        {!!counts.unspecified && (
          <p className="text-xs text-amber-700" title="Approved without a relationship type. Set it via Edit on the attendee card.">
            Unspecified: {counts.unspecified}
          </p>
        )}
      </div>
    </div>
  );
};

export default AttendeeStats;